<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route(to, from) {
      if(to.path == '/backlogin'){
        localStorage.clear();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue